import React from "react";
import { NcCompareContext } from "../../../../common-deprecated/types/NewCarCompareTypes";
import useIntegratedCompare from "../../hooks/useIntegratedCompare";
import CompareToyota from "./CompareToyota";

type PropsType = {
    mode?: NcCompareContext;
    financeProduct?: string;
};
const IntegratedCompareToyota = ({
    mode = NcCompareContext.Original,
    financeProduct = undefined,
}: PropsType): JSX.Element | null => {
    const { fetching } = useIntegratedCompare(mode, financeProduct);

    return fetching ? null : <CompareToyota />;
};

export default IntegratedCompareToyota;
